import { createContext, useContext, useState, useEffect } from 'react';
import { AccountContext } from '../context/account-context';
import { TasksCounterProvider } from '../context/tasks-counter-context';
import { TasksProvider } from '../context/tasks-context';
import PaneRight from './pane-right';
import PaneLeft from './pane-left';
import './messages-container.scss';
import { RecipientProvider } from '../context/recipient-context';
import { ReadProvider } from '../context/read-context';
import { CompleteProvider } from '../context/complete-context';
import { SocketProvider } from '../context/socket-context';
import { RecipientsProvider } from '../context/recipients-context';

export default function Messages() {

    const [account, setAccount] = useContext(AccountContext);
    const [localAccount, setLocalAccount] = useState(account);

    useEffect(() => {
        setLocalAccount(account);
    }, [account]);

    if (!localAccount)
        return <></>

    return (

        <SocketProvider>
            <RecipientsProvider>
                <RecipientProvider>
                    <TasksProvider>
                        <ReadProvider>
                            <CompleteProvider>
                                <div className="pane">
                                    <div className="pane-left-container">
                                        <PaneLeft></PaneLeft>
                                    </div>

                                    <div className="pane-right-container">
                                        <PaneRight></PaneRight>
                                    </div>
                                </div>
                            </CompleteProvider>
                        </ReadProvider>
                    </TasksProvider>
                </RecipientProvider>
            </RecipientsProvider>
        </SocketProvider>


    );
}

